import axios from "axios";
export function get(id) {
  return axios.get(`/api/parties/${id}?returnType=full`).then(res => res.data);
}

export function patch(id, patchDoc) {
  return axios.patch(`/api/parties/${id}`, patchDoc);
}
